import RemindersSettings from './remindersSettings.view';

export default RemindersSettings;
